import { css } from "../../../styled-system/css";

const PHONE_INPUT_HEIGHT = "54px";

export const styles = {
  root: () =>
    css({
      width: "100%",
    }),

  inputWrapper: () =>
    css({
      position: "relative",
      width: "100%",
    }),

  container: (hasError: boolean, disabled: boolean, isFocused: boolean) =>
    css({
      display: "flex",
      alignItems: "stretch",
      height: PHONE_INPUT_HEIGHT,
      borderRadius: "4px",
      border: "1px solid",
      borderColor: hasError ? "red" : "headlineGrey",
      backgroundColor: disabled ? "backgroundGrey" : "white",
      transition: "border-color .2s ease-in-out",
      outline: isFocused ? "2px solid" : "none",
      outlineColor: isFocused ? "linkBlue" : undefined,
      outlineOffset: isFocused ? "2px" : undefined,
      ...(hasError && {
        borderColor: "red",
      }),
      ...(disabled && {
        borderColor: "disabledGrey",
      }),
    }),

  prefixButton: (disabled: boolean) =>
    css({
      display: "flex",
      alignItems: "center",
      gap: "baseUnit.mobile1",
      paddingLeft: "baseUnit.mobile2",
      paddingRight: "baseUnit.mobile1",
      backgroundColor: "transparent",
      border: "none",
      borderRight: "1px solid",
      borderRightColor: "disabledGrey",
      cursor: disabled ? "default" : "pointer",
      flexShrink: 0,
      minWidth: "80px",
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
      color: "headlineGrey",
      opacity: disabled ? 0.4 : 1,
    }),

  prefixArrow: (isOpen: boolean) =>
    css({
      flexShrink: 0,
      transition: "transform 0.3s ease",
      width: "10px",
      height: "8px",
      transform: isOpen ? undefined : "rotate(180deg)",
    }),

  input: (disabled: boolean) =>
    css({
      flex: 1,
      border: "none",
      outline: "none",
      paddingLeft: "baseUnit.mobile2",
      paddingRight: "baseUnit.mobile2",
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
      color: disabled ? "lightGrey" : "headlineGrey",
      backgroundColor: "transparent",
      _placeholder: {
        color: "lightGrey",
      },
    }),

  label: (hasError: boolean) =>
    css({
      display: "block",
      marginBottom: "4px",
      fontSize: "body.butterfly",
      lineHeight: "body.butterfly",
      letterSpacing: "body.butterfly",
      color: hasError ? "red" : "headlineGrey",
      fontWeight: 400,
    }),

  message: (hasError: boolean) =>
    css({
      fontSize: "body.mouse",
      lineHeight: 1.2,
      letterSpacing: "body.mouse",
      color: hasError ? "red" : "stdTextGrey",
      paddingTop: "4px",
      paddingLeft: "baseUnit.mobile2",
    }),

  dropdown: () =>
    css({
      position: "absolute",
      top: "100%",
      left: 0,
      width: "100%",
      maxHeight: "220px",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      marginTop: "baseUnit.mobile1",
      paddingTop: "baseUnit.mobile1",
      paddingBottom: "baseUnit.mobile1",
      paddingLeft: "baseUnit.mobile2",
      paddingRight: "baseUnit.mobile2",
      backgroundColor: "white",
      borderRadius: "baseUnit.mobile1",
      boxShadow: "verySoftBottomRight",
      zIndex: "overShadow",
      userSelect: "none",
    }),

  dropdownList: () =>
    css({
      flex: 1,
      overflow: "auto",
      margin: 0,
      padding: 0,
      listStyle: "none",
    }),

  searchInput: () =>
    css({
      width: "100%",
      border: "1px solid",
      borderColor: "disabledGrey",
      borderRadius: "4px",
      padding: "baseUnit.mobile1",
      marginBottom: "baseUnit.mobile1",
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
      color: "headlineGrey",
      outline: "none",
      _focus: {
        borderColor: "linkBlue",
      },
      _placeholder: {
        color: "lightGrey",
      },
    }),

  option: () =>
    css({
      display: "flex",
      alignItems: "center",
      gap: "baseUnit.mobile1",
      padding: "baseUnit.mobile1",
      cursor: "pointer",
      borderRadius: "4px",
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
      color: "headlineGrey",
      _hover: {
        fontWeight: 700,
      },
      _focus: {
        fontWeight: 700,
        outline: "2px solid",
        outlineColor: "linkBlue",
        outlineOffset: "-2px",
      },
    }),

  optionDialCode: () =>
    css({
      color: "stdTextGrey",
      minWidth: "44px",
    }),

  noResults: () =>
    css({
      padding: "baseUnit.mobile1",
      color: "stdTextGrey",
      fontSize: "body.mouse",
    }),
};
